// ⚠️ AUTO-GENERATED FROM CORE REPO
// DO NOT EDIT — changes will be overwritten

/* Presentation only: a one-shot pulse for visibly changed discount values. */
(() => {
  if (window.GoatDiscountMotion) return;
  const active = new WeakMap();
  window.GoatDiscountMotion = {
    pulse(element) {
      if (!element || element.hidden || !element.animate ||
          window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      active.get(element)?.cancel();
      const animation = element.animate([
        { transform: "scale(1)", opacity: 1 },
        { transform: "scale(1.035)", opacity: 0.78, offset: 0.45 },
        { transform: "scale(1)", opacity: 1 },
      ], { duration: 360, easing: "ease-out" });
      active.set(element, animation);
      animation.onfinish = animation.oncancel = () => {
        if (active.get(element) === animation) active.delete(element);
      };
    },
  };
})();
